module.exports = __webpack_public_path__ + "static/media/flecha_back1.79b765d8.svg";